import { SVGProps } from "react"

const RishoPhone = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.3082 15.275C18.3082 15.575 18.2415 15.8833 18.0998 16.1833C17.9582 16.4833 17.7748 16.7666 17.5332 17.0333C17.1248 17.4833 16.6748 17.8083 16.1665 18.0166C15.6665 18.225 15.1248 18.3333 14.5415 18.3333C13.6915 18.3333 12.7832 18.1333 11.8248 17.725C10.8665 17.3166 9.90817 16.7666 8.95817 16.075C7.99984 15.375 7.0915 14.6 6.22484 13.7416C5.3665 12.875 4.5915 11.9666 3.89984 11.0166C3.2165 10.0666 2.6665 9.11663 2.2665 8.17496C1.8665 7.22496 1.6665 6.31663 1.6665 5.44996C1.6665 4.88329 1.7665 4.34163 1.9665 3.84163C2.1665 3.33329 2.48317 2.86663 2.92484 2.44996C3.45817 1.92496 4.0415 1.66663 4.65817 1.66663C4.8915 1.66663 5.12484 1.71663 5.33317 1.81663C5.54984 1.91663 5.7415 2.06663 5.8915 2.28329L7.82484 5.00829C7.97484 5.21663 8.08317 5.40829 8.15817 5.59163C8.23317 5.76663 8.27484 5.94163 8.27484 6.09996C8.27484 6.29996 8.2165 6.49996 8.09984 6.69163C7.9915 6.88329 7.83317 7.08329 7.63317 7.28329L6.99984 7.94163C6.90817 8.03329 6.8665 8.14163 6.8665 8.27496C6.8665 8.34163 6.87484 8.39996 6.8915 8.46663C6.9165 8.53329 6.9415 8.58329 6.95817 8.63329C7.10817 8.90829 7.3665 9.26663 7.73317 9.69996C8.10817 10.1333 8.50817 10.575 8.9415 11.0166C9.3915 11.4583 9.82484 11.8666 10.2665 12.2416C10.6998 12.6083 11.0582 12.8583 11.3415 13.0083C11.3832 13.025 11.4332 13.05 11.4915 13.075C11.5582 13.1 11.6248 13.1083 11.6998 13.1083C11.8415 13.1083 11.9498 13.0583 12.0415 12.9666L12.6748 12.3416C12.8832 12.1333 13.0832 11.975 13.2748 11.875C13.4665 11.7583 13.6582 11.7 13.8665 11.7C14.0248 11.7 14.1915 11.7333 14.3748 11.8083C14.5582 11.8833 14.7498 11.9916 14.9582 12.1333L17.7165 14.0916C17.9332 14.2416 18.0832 14.4166 18.1748 14.625C18.2582 14.8333 18.3082 15.0416 18.3082 15.275Z"
        stroke={props.color || "white"}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M15.4167 7.50004C15.4167 7.00004 15.025 6.23337 14.4417 5.60837C13.9083 5.03337 13.2 4.58337 12.5 4.58337"
        stroke={props.color || "white"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3333 7.49996C18.3333 4.27496 15.725 1.66663 12.5 1.66663"
        stroke={props.color || "white"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export default RishoPhone
